@if (usage?.folderCount > 0) {
  <div class="usage-hint">
    <mat-icon>info_outline</mat-icon>
    <span>{{ usageText(usage) }} Die Nutzer werden über Änderungen benachrichtigt.</span>
  </div>
}
